WL.registerComponent('lookAt', {
    target: {type: WL.Type.Object},
}, {
    init: function() {
        console.log('init() with param', this.param);
    },
    start: function() {
        console.log('start() with param', this.param);
    },
    update: function(dt) {
        this.object.lookAt(target.localTransform);
    },
});
